import {z, ZodObject, ZodRawShape} from 'zod';
import i18n from '../../../i18n';

export const ImportUserHeaderCSVSchema = z.object({
    email: z.string().refine((val) => val.toLowerCase() === 'email', {
        message: i18n.t('registerPage.importUsers.headerErrors.email'),
    }),
    username: z
        .string()
        .optional()
        .refine((val) => (val ? val.toLowerCase() === 'username' : true), {
            message: i18n.t('registerPage.importUsers.headerErrors.wrongHeader'),
        }),
    password: z
        .string()
        .optional()
        .refine((val) => (val ? val.toLowerCase() === 'password' : true), {
            message: i18n.t('registerPage.importUsers.headerErrors.wrongHeader'),
        }),
});

export const getSchemaKeys = (schema: ZodObject<ZodRawShape>): string[] => {
    return Object.keys(schema.shape);
};

export const emailSchema = z.string().email();
